import React from "react";

import { trackEvent } from "../analytics";

const ELITEALARMS_URL = "https://elitealarms.com";

const EliteAlarmsMigrationBanner = () => {
  const handleBannerClick = () => {
    trackEvent("migration_banner_click", {
      link_url: ELITEALARMS_URL,
      link_text: "elitealarms.com",
    });
  };

  return (
    <div className="banner migration-banner">
      <div className="banner-inner text-center">
        <p className="bannerText">
          We&apos;re excited to introduce{" "}
          <a
            href={ELITEALARMS_URL}
            className="bannerLink"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleBannerClick}
          >
            elitealarms.com
          </a>
          , your new central hub for EliteAlarms information, support, and cloud
          services.
        </p>
      </div>
    </div>
  );
};

export default EliteAlarmsMigrationBanner;
